import React from "react";
import style from "./style.module.css";

function index({ icon, title, text }) {
  return (
    <div className={style.card}>
      <div className={style.icon}>
        <img src={icon} alt={title} width={64} height={64} />
      </div>
      <div className={style.textsContainer}>
        <p>{title}</p>
        <p>{text}</p>
      </div>
    </div>
  );
}

export default index;
